// Palette slot for a calendar: its position in the FULL calendar list, never in
// the list of calendars currently shown. Taking the slot from the visible list
// made every calendar after a hidden one take over its neighbour's colour
// (TICKET-01736). Returns -1 when the calendar is not in the list.

export function getCalendarColorIdx(calendars, value, key = 'id') {
    if (!calendars || typeof calendars.findIndex !== 'function') return -1;
    return calendars.findIndex(c => c && c[key] === value);
}

// Background colour for a calendar's appointments: the colour set on the
// calendar itself wins, otherwise its palette slot. Returns null when neither
// is available, so the caller can apply its own fallback.
export function getCalendarBackgroundColor(calendars, colors, value, key = 'id') {
    const idx = getCalendarColorIdx(calendars, value, key);
    if (idx < 0) return null;
    return calendars[idx].backgroundColor || colors?.[idx]?.backgroundColor || null;
}
